/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetTicketDetails } from "services/tickets";
import Loader from "ui/page-loader";
import { useUser } from "hooks/use-user";
import { isCallCenterAgent } from "../utils";
import ServiceCallDetails from "./service-call-details";
import FacilitiesDetails from "./facilities-details";
import CustomerServiceDetails from "./customer-service-detail";
import EtisalatThirdPartyDetails from "./etisalat-third-party.-details";
import RemoteSupportDetails from "./remote-support-details";
import CustomerComplaintDetails from "./customer-complaint-details";
import UnusualEventsDetails from "./unusual-events-details";

export default function TicketDetails() {
  const params = useParams();
  const user = useUser();
  const isCCA = isCallCenterAgent(user);

  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicketDetails,
  } = useGetTicketDetails();

  useEffect(() => {
    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);

  return (
    <>
      {gettingTicketDetails ? (
        <Loader />
      ) : (
        <>
          {ticketDetailsRes?.data.isServiceTicket ? (
            <ServiceCallDetails ticketData={ticketDetailsRes.data} />
          ) : ticketDetailsRes?.data.activityType === "Facilities Request" ? (
            <FacilitiesDetails ticketData={ticketDetailsRes.data} />
          ) : ticketDetailsRes?.data.activityType === "Customer Service" ? (
            <CustomerServiceDetails ticketData={ticketDetailsRes.data} />
          ) : ticketDetailsRes?.data.activityType ===
            "ETISALAT – Third Party" ? (
            <EtisalatThirdPartyDetails ticketData={ticketDetailsRes.data} />
          ) : ticketDetailsRes?.data.activityType === "TGM Remote Support" ? (
            <RemoteSupportDetails ticketData={ticketDetailsRes.data} />
          ) : ticketDetailsRes?.data.activityType === "Customer Complaints" ? (
            <CustomerComplaintDetails ticketData={ticketDetailsRes.data} />
          ) : ticketDetailsRes?.data.activityType === "Unusual Event" ? (
            <UnusualEventsDetails ticketData={ticketDetailsRes.data} />
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
}
